import React from 'react';

import { MarketplaceSaleChannelType } from '@anyx/common-graphql';

const LazadaAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.LazadaAddPage }))
);

const LazadaEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.LazadaEditPage }))
);

const LazadaTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.LazadaTemplate }))
);

export const lazadaRouting = [
  {
    path: MarketplaceSaleChannelType.Lazada,
    element: <LazadaTemplate />,
    children: [
      {
        index: true,
        element: <LazadaAddPage />,
      },
      {
        path: ':channelId',
        children: [
          {
            index: true,
            element: <LazadaEditPage />,
          },
        ],
      },
    ],
  },
];
